export default __webpack_public_path__ + "static/media/s4.c4cd894f.png";